import React from "react";
import {
  Grid,
  Typography,
  Paper,
  TextField,
  InputAdornment,
  Button,
  Checkbox,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import * as EmailValidator from "email-validator";
import LanguageSwitcher from "../../../utilities/LanguageSwitcher";
import AuthContext from "../../../contexts/AuthContext";
import { confirm, resendCode, login } from "../../../utilities/authFlow";
import { useTranslation } from "react-i18next";

const Confirm = ({ setPage, pw }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { email, setEmail, appStyle, appConfig, setSignedIn } =
    React.useContext(AuthContext);
  const [code, setCode] = React.useState("");
  const [emailError, setEmailError] = React.useState(null);
  const [error, setError] = React.useState("");

  const validateEmail = () => {
    console.log("validating email");
    const valid = EmailValidator.validate(email);
    if (!valid) {
      setEmailError(true);
      return false;
    }

    setEmailError(null);
    return true;
  };

  const handleConfirm = async () => {
    if (!validateEmail()) {
      setEmailError(true);
      return;
    }
    setError(null);
    const result = await confirm(email, code);
    if (result.success) {
      console.log("confirmed!");
      const loginResult = await login(email, pw);
      if (loginResult.success) {
        setSignedIn(true);
        setPage("login");
      } else {
        setPage("success");
      }
    } else {
      setError(result.error);
    }
  };

  const handleSendNewCode = async () => {
    const result = await resendCode(email);
    if (result.success) {
      alert(t('auth.confirm.codehasbeensent'));
    }
  };

  return (
    <Grid container spacing={3} justifyContent="center">
      <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
        <img src={appStyle?.logo} height="175px" />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        lg={4}
        style={{ display: "flex", justifyContent: "center" }}
      >
        {/* <form style={{ display: "flex", justifyContent: "center" }}> */}
        <Paper elevation={3} style={{ width: "100%", padding: 10 }}>
          <Grid container direction="column" spacing={3}>
            <Grid item style={{ marginTop: 20, marginBottom: 0 }}>
              <Typography variant="h5" align="center">
                {t("auth.confirm.title")}
              </Typography>
            </Grid>
            <Grid item style={{ marginTop: 0, marginBottom: 20 }}>
              <Typography variant="subtitle2" align="center">
                {t("auth.confirm.instructions")}
              </Typography>
            </Grid>
            {error ? (
              <Grid item style={{ display: "flex", justifyContent: "center" }}>
                <Typography
                  variant="subtitle2"
                  style={{ color: theme.palette.primary.main }}
                >
                  {error}
                </Typography>
              </Grid>
            ) : (
              <></>
            )}
            <Grid item style={{ display: "flex", justifyContent: "center" }}>
              <TextField
                label={t("email.textbox.label")}
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={t("email.textbox.placeholder")}
                style={{ width: "90%" }}
                sx={{
                  fieldset: { borderColor: "red" },
                }}
                autoComplete="off"
                onBlur={validateEmail}
                error={emailError ? true : false}
                helperText={emailError ? t("email.textbox.error") : ""}
              />
            </Grid>
            <Grid item style={{ display: "flex", justifyContent: "center" }}>
              <TextField
                autoFocus
                margin="dense"
                label={t("auth.confirm.code.label")}
                variant="outlined"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder={t("auth.confirm.code.placeholder")}
                style={{ width: "90%" }}
                autoComplete="off"
                inputProps={{ inputMode: "numeric" }}
              />
            </Grid>
            <Grid item style={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                style={{
                  width: "90%",
                  height: 40,
                  backgroundColor: theme.palette.primary.main,
                }}
                onClick={handleConfirm}
              >
                {t("auth.confirm.button")}
              </Button>
            </Grid>
            <Grid item style={{ marginTop: 0, marginBottom: 0 }}>
              <Typography
                variant="subtitle2"
                align="center"
                style={{ paddingLeft: 10, paddingRight: 10 }}
              >
                {t("auth.confirm.resend.label")}{" "}
                <span
                  onClick={handleSendNewCode}
                  style={{
                    color: theme.palette.primary.main,
                    cursor: "pointer",
                  }}
                >
                  {t("auth.confirm.resend.link")}
                </span>{" "}
                {t("auth.confirm.resend.suffix")}
              </Typography>
            </Grid>
            <Grid item style={{ marginTop: 0, marginBottom: 0 }}>
              <Typography
                variant="subtitle2"
                align="center"
                style={{ paddingLeft: 10, paddingRight: 10 }}
              >
                Having trouble? Click{" "}
                <span
                  onClick={() => setPage("troubleshoot")}
                  style={{
                    color: theme.palette.primary.main,
                    cursor: "pointer",
                  }}
                >
                  here
                </span>{" "}
                to troubleshoot.
              </Typography>
            </Grid>
            <Grid item style={{ display: "flex", justifyContent: "center" }}>
              <Button
                style={{
                  width: "90%",
                  height: 40,
                  color: theme.palette.primary.main,
                }}
                onClick={() => setPage("login")}
              >
                {t("auth.backtologin.btn")}
              </Button>
            </Grid>
          </Grid>
        </Paper>
        {/* </form> */}
      </Grid>
      <Grid item xs={12}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography align="center" style={{ color: "#353535" }}>
              {t("footer.copyright")}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              align="center"
              style={{ color: "#353535" }}
              onClick={() => window.open(appConfig?.privacyPolicy, "_blank")}
            >
              {t("privacypolicy.link")}
            </Typography>
          </Grid>
          <Grid item style={{ marginBottom: 50 }}>
            <LanguageSwitcher />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Confirm;
